export const authentication = {
    displayLoginLogo: false,
    enableSSO: false,
};